let mainPath = "/stocktaking";
let viewFolder = "Stocktaking";

module.exports = [
    {
        path: mainPath,
        name: 'Stocktaking',
        component: () => import(/* webpackChunkName: "Warehouse" */ '../views/'+viewFolder+'/Index.vue'),
    },
]